import { Box, Button, LinearProgress, Stack, Typography } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { useParams } from "react-router-dom";
import { MatchParam } from "src/constants/matches";
import DataTable from "src/components/DataTable";
import { useMemo } from "react";
import { useGetVariantsForExperimentQuery } from "src/api/services/experimentsApi";
import { useColumns } from "./utils/columns";
import AddIcon from "@mui/icons-material/Add";
import { useManageModal } from "src/hooks/useManageModal";
import CreateNewVariantModal from "src/components/Modals/CreateNewVariantModal";

const ExperimentVariants = () => {
  const [open, { handleClose, handleOpen }] = useManageModal();
  const { experimentId } = useParams<MatchParam<"EXPERIMENT_ID">>();
  const { data = [], isFetching } = useGetVariantsForExperimentQuery(
    experimentId ?? skipToken,
  );
  // const [open, { handleClose, handleOpen }] = useManageModal();
  const columns = useColumns();
  const height = useMemo(() => window.innerHeight - 104 - 64 - 34, []);

  return (
    <Stack gap={2} sx={{ width: "100%", minWidth: 0 }}>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h4">Variants</Typography>
        <Button startIcon={<AddIcon />} onClick={handleOpen}>
          Add New
        </Button>
      </Stack>
      <Stack gap={0} sx={{ width: "100%", minWidth: 0 }}>
        <Box height={4}>{isFetching ? <LinearProgress /> : null}</Box>
        <DataTable
          columns={columns}
          data={data}
          primaryKey="id"
          height={height}
        />
      </Stack>

      <CreateNewVariantModal
        open={open}
        onClose={handleClose}
        experimentId={experimentId}
      />
    </Stack>
  );
};

export default ExperimentVariants;
